import React from "react";
import { Toggle, ISearchFilter } from  '@/interfaces/insightsp2';

const DateLabelBuilder = ({toggle, searchFilterOptions}:{toggle:Toggle, searchFilterOptions:ISearchFilter}):JSX.Element => {

    let label = toggle === Toggle.date1 ?  `${searchFilterOptions.date1.label}` : searchFilterOptions.date2.label;

    // Temp remove date from label
    label = label.includes('(') ? label.split('(')[0] : label;

    const selectedDate = toggle === Toggle.date1 ?  searchFilterOptions.date1 : searchFilterOptions.date2;

    const dateFrom = selectedDate.dateFrom.toLocaleDateString();

    const dateTo = selectedDate.dateTo.toLocaleDateString();       

    const dateString = dateFrom === dateTo ? dateFrom : `(${dateFrom} - ${dateTo})`;

    return (

        <span className="label intooltip">
            {label}
            <span className="tooltiptext">{dateString}</span>
        </span>
  
    )
}

export default DateLabelBuilder;
